import { Anchor, Box, Heading, List, Paragraph } from '@zillow/constellation-10';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';

import RoommateDescriptionFormField from '../../../PostingPath/RoommateDescriptionFormField';
import PageWizard from '../../../Wizard/PageWizard';
import WizardTipCardContainer from '../../../WizardTipCardContainer';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const RoommateDescription = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
    >
      <Box css={wizardFlexContainerStyles}>
        <Box css={wizardFormSectionContainerStyles.raw()}>
          <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
            Describe the roommates
          </Heading>

          <Box css={wizardParagraphStyles}>
            <Paragraph css={{ marginBottom: '400' }}>
              Write several sentences describing the roommates. This should include information such as their daily
              routines, profession, hobbies, or interests.
            </Paragraph>
            <Paragraph>
              See our{' '}
              <Anchor
                href="https://www.zillow.com/rental-manager/respectful-renting-pledge/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Respectful Renting Pledge
              </Anchor>{' '}
              for guidance on language to avoid so you don’t include discriminatory language.
            </Paragraph>
          </Box>

          <RoommateDescriptionFormField />
        </Box>

        <WizardTipCardContainer header="Tips for describing roommates">
          <List.Root css={{ paddingLeft: '600' }}>
            <List.Item>
              Include details about occupations, hobbies, and interests to help the renter determine if they’ll be a
              good fit.
            </List.Item>
            <List.Item>
              Be sure to mention personal schedules, especially if someone works from home or needs to sleep during the
              day because they work nights.
            </List.Item>
            <List.Item>
              Note any preferences about common activities such as cleaning, cooking, and having guests over.
            </List.Item>
          </List.Root>
        </WizardTipCardContainer>
      </Box>
    </PageWizard>
  );
};

export default RoommateDescription;
